var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5435 14.2857V0H22.2391V14.2857H35.2826V23.8095H22.2391V38.0952H13.5435V23.8095H0.5V14.2857H13.5435ZM26.587 42.8571V28.5714H39.6304V14.2857H70.0652L78.0217 23.8095H91.8043C96.587 23.8095 100.5 28.0952 100.5 33.3333V90.4762C100.5 95.7143 96.587 100 91.8043 100H22.2391C17.4565 100 13.5435 95.7143 13.5435 90.4762V42.8571H26.587ZM57.0217 85.7143C69.0217 85.7143 78.7609 75.0476 78.7609 61.9048C78.7609 48.7619 69.0217 38.0952 57.0217 38.0952C45.0217 38.0952 35.2826 48.7619 35.2826 61.9048C35.2826 75.0476 45.0217 85.7143 57.0217 85.7143ZM43.1087 61.9048C43.1087 70.3333 49.3261 77.1429 57.0217 77.1429C64.7174 77.1429 70.9348 70.3333 70.9348 61.9048C70.9348 53.4762 64.7174 46.6667 57.0217 46.6667C49.3261 46.6667 43.1087 53.4762 43.1087 61.9048Z",
    fill: "#1A96F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8cf8a9685deb9184d7f23558b6b03007.svg";
export { ForwardRef as ReactComponent };